import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BeepService {

  private readonly iOS: boolean;
  soundsEnabled = new BehaviorSubject<boolean>(true);

  private beepAudio: HTMLAudioElement;
  private bopAudio: HTMLAudioElement;

  constructor() {
    this.beepAudio = new Audio();
    this.bopAudio = new Audio();
    this.iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (this.iOS) {
      this.soundsEnabled.next(false);
    }
  }

  /**
   * Beep in response to any code scanned, without knowing if it's positive or not.
   */
  scanBeep(): void {
    if (!this.soundsEnabled.value) {
      return;
    }
    this.beepAudio.src = '/assets/sounds/beep.mp3';
    this.beepAudio.play().catch(reason => {
      console.error(`Failed to play sound: ${reason}`);
    });
  }

  /**
   * Reacts to a positive code scanned, i.e. a code that resulted in a positive interaction (package scanned)
   */
  beep(): void {
    if (!this.soundsEnabled.value) {
      return;
    }

    this.beepAudio.src = '/assets/sounds/positive.mp3';
    this.beepAudio.play().catch(reason => {
      console.error(`Failed to play sound: ${reason}`);
    });
  }

  /**
   * Reacts to a negative code scanned, i.e. package not found
   */
  bop(): void {
    if (!this.soundsEnabled.value) {
      return;
    }

    this.bopAudio.src = '/assets/sounds/negative.mp3';
    this.bopAudio.play().catch(reason => {
      console.error(`Failed to play sound: ${reason}`);
    });
  }

  enableSounds(enable: boolean): void {
    this.soundsEnabled.next(enable);
    if (enable && this.iOS) {
      this.beepAudio = new Audio();
      this.beepAudio.play();
      this.bopAudio = new Audio();
      this.bopAudio.play();
    }
  }

}
